"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ethParamToChainResponse = ethParamToChainResponse;
exports.isArrayResponse = isArrayResponse;
exports.isPrimitiveResponse = isPrimitiveResponse;
exports.isStructResponse = isStructResponse;
var _ethTypes = require("@blockwell/eth-types");
function isStructResponse(res) {
  if (typeof res === "number" || typeof res === "boolean" || typeof res === "string") {
    return false;
  }
  if (Array.isArray(res)) {
    return false;
  }
  return !!res;
}
function isArrayResponse(res) {
  return Array.isArray(res);
}
function isPrimitiveResponse(res) {
  return !Array.isArray(res) && !isStructResponse(res);
}
function ethParamToChainResponse(param) {
  if ((0, _ethTypes.isStringArrayParameter)(param) || (0, _ethTypes.isBooleanArrayParameter)(param)) {
    return param.values;
  }
  if ((0, _ethTypes.isStringParameter)(param) || (0, _ethTypes.isBooleanParameter)(param)) {
    return param.value;
  }
  if ((0, _ethTypes.isTupleArrayParameter)(param)) {
    return param.values.map(ethParamToChainResponse);
  }
  if ((0, _ethTypes.isTupleParameter)(param)) {
    return Object.fromEntries(param.components.map(comp => [comp.name, ethParamToChainResponse(comp)]));
  }
  return param.hash;
}
//# sourceMappingURL=ChainResponse.js.map